/* eslint-disable no-param-reassign */

import moment from 'moment';
import { maxBy, reverse, find, filter, sortBy } from 'lodash';
import * as MutationTypes from '@/store/mutation-types';
import InvestmentsApi from '@/backend/api/Investments';
import { fetchResource, getIncludedData, getIncludedGoogleDocByKind, getArrayIncludedData } from '@/utils';
import { assignHelper, fetchList } from '../helpers';

export default {
  namespaced: true,
  state: {
    list: [],
    show: null,
  },
  getters: {
    getDocuments: ({ show }, { participation }) => (kind) => {
      if (show) {
        const documents = participation.relationships.googleDriveDocuments.data;
        const filterByKind = ({ attributes }) => (attributes.kind === kind);
        return reverse(sortBy(
          filter(documents.map(doc => find(show.included, doc)), filterByKind),
          'attributes.weight',
        ));
      }
      return [];
    },
    reportings: (_, { getDocuments }) => getDocuments('Quarterly Report'),
    financialStatementDocuments: (_, { getDocuments }) => getDocuments('Financial Statement'),
    companyAdminDocuments: (_, { getDocuments }) => getDocuments('Company Admin'),
    peaDocuments: ({ show }) => getIncludedGoogleDocByKind(show, 'PEA Document'),
    operationsDocuments: ({ show }) => getIncludedGoogleDocByKind(show, 'Operations Document'),
    participation: ({ show }) =>
      getIncludedData(show, 'participation'),
    operation: ({ show }) => show && maxBy(filter(show.included, { type: 'spvFinancialOperation' }), operation => moment(operation.attributes.date).toDate()),
    operations: ({ show }) => show && filter(show.included, { type: 'spvFinancialOperation' }),
    spv: ({ show }) =>
      getIncludedData(show, 'spv'),
    participationOperation: ({ show }, { spv }) =>
      show && find(
        show.included,
        spv.relationships.lastParticipationOperation.data,
      ),
    participationOperations: ({ show }, { spv }) =>
      show &&
        spv.relationships.participationOperations.data.map(el =>
          find(show.included, el)),
    siblings: ({ show }) => getArrayIncludedData(show, 'siblings'),
    getOperation: ({ show }) => id =>
      show && find(show.included, {
        type: 'spvFinancialOperation',
        id,
      }),
  },
  mutations: {
    [MutationTypes.SET_INVESTMENTS]: assignHelper('list'),
    [MutationTypes.SET_INVESTMENT_SHOW]: assignHelper('show'),
  },
  actions: {
    fetchList({ commit }) {
      return InvestmentsApi.list().then((response) => {
        commit(MutationTypes.SET_INVESTMENTS, response.data);
      });
    },
    fetch: fetchResource(InvestmentsApi, MutationTypes.SET_INVESTMENT_SHOW),
  },
};
